module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0040.jpg?v=0c0567c5";